import React,{ useState,useEffect } from 'react';
import { HiHand } from 'react-icons/hi';

import { images } from '../../constants';
import { AppWrap,MotionWrap } from '../../wapper';
import {urlFor,client} from '../../client';
import './Footer.scss';
const Footer = () => {
  const [formData, setFormData] = useState({ name:'',email:'',message:'' });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const {name,email,message} = formData;

  const HandleChangeInput = (e) =>{
    const {name,value} = e.target;

    setFormData({...formData, [name]: value});
  } 

  const HandleSubmit = () =>{
    setLoading(true);

    const contact = {
      _type:'contact',
      name: name,
      email: email,
      message: message
    }

    client.create(contact)
      .then(() =>{
        setLoading(false);
        setIsFormSubmitted(true);
      })
  }
  return (
    <>
      <h2 className='head-text'>Take a Coffee and Chat with me</h2>

      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.email} alt="" />
          <a href="mailto:kittu2000.me@gmail.com">kittu2000.me@gmail.com</a>
        </div>
        <div className="app__footer-card">
          <img src={images.mobile} alt="" />
          <a href="tel:+91 8160032383">+91 8160032383</a>
        </div>
      </div>
      {!isFormSubmitted ? 
      <div className="app__footer-form app__flex">
          <div className='app__flex'>
            <input className='p-text' type='text' placeholder='Your name' name='name' value={name} onChange={HandleChangeInput} required/>
          </div>
          <div className='app__flex'>
            <input className='p-text' type='email' placeholder='Your email' name='email' value={email} onChange={HandleChangeInput} required/>
          </div>
          <div>
            <textarea className='p-text' name="message" value={message}   placeholder='Your message' onChange={HandleChangeInput} required></textarea>
          </div>
          <button type='button' className='p-text' onClick={HandleSubmit}>{loading ? 'Sending' : 'Send Message'}</button>
      </div> 
      : <div>
          <h3 className='head-text'>Thakyou for getting in touch!</h3>
      </div>}
    </>
  )
}

export default AppWrap(MotionWrap(Footer,'app__footer'), 'contact', "app__whitebg")